var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 16H5C5.28333 16 5.52083 16.0958 5.7125 16.2875C5.90417 16.4792 6 16.7167 6 17C6 17.2833 5.90417 17.5208 5.7125 17.7125C5.52083 17.9042 5.28333 18 5 18H1C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17V13C0 12.7167 0.0958333 12.4792 0.2875 12.2875C0.479167 12.0958 0.716667 12 1 12C1.28333 12 1.52083 12.0958 1.7125 12.2875C1.90417 12.4792 2 12.7167 2 13V14.6L4.4 12.2C4.58333 12.0167 4.81667 11.925 5.1 11.925C5.38333 11.925 5.61667 12.0167 5.8 12.2C5.98333 12.3833 6.075 12.6167 6.075 12.9C6.075 13.1833 5.98333 13.4167 5.8 13.6L3.4 16ZM16 3.4L13.6 5.8C13.4167 5.98333 13.1833 6.075 12.9 6.075C12.6167 6.075 12.3833 5.98333 12.2 5.8C12.0167 5.61667 11.925 5.38333 11.925 5.1C11.925 4.81667 12.0167 4.58333 12.2 4.4L14.6 2H13C12.7167 2 12.4792 1.90417 12.2875 1.7125C12.0958 1.52083 12 1.28333 12 1C12 0.716667 12.0958 0.479167 12.2875 0.2875C12.4792 0.0958333 12.7167 0 13 0H17C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1V5C18 5.28333 17.9042 5.52083 17.7125 5.7125C17.5208 5.90417 17.2833 6 17 6C16.7167 6 16.4792 5.90417 16.2875 5.7125C16.0958 5.52083 16 5.28333 16 5V3.4Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanZoom);
export default __webpack_public_path__ + "static/media/pan_zoom.b84ebaf1fcb48f53a4380b41285f8402.svg";
export { ForwardRef as ReactComponent };